<style lang="scss" scoped>
.slide-16 {
  background-image: url(../../../assets/module1/slide11/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 60px;
  height: calc(100% - 60px);
  padding-left: 100px;
  padding-top: 60px;
  display: flex;
  flex-direction: column;
}
header {
  transform: rotate(-2deg);
  margin-bottom: 60px;
}
h1 {
  font-size: 92px;
}
h2 {
  font-size: 92px;
  color: #e30613;
}
h3 {
  font-size: 54px;
}
h4 {
  font-size: 64px;
  color: #e30613;
}
.btn {
  transition: all 0.2s ease-out;
  display: block;
  width: 400px;
  position: absolute;
  right: 50px;
  bottom: 75px;
  img {
    width: 100%;
    height: auto;
  }
  &:hover {
    transform: scale(1.1);
  }
}
.flex {
  margin-top: auto;
  height: auto;
  margin-bottom: 140px;
}
p {
  color: white;
}
.left {
  max-width: 705px;
  margin-right: 40px;
}
.right {
  max-width: 417px;
  padding-left: 175px;
}
video {
  outline: none !important;
  position: absolute;
  top: 283px;
  left: 1021px;
  z-index: 1;
  width: 819px;
  height: 457px;
  background: black;
  border-radius: 23px;
}
</style>

<template>
  <div class="slide-16">
    <header>
      <transition name="fadeUp" appear>
        <h1 v-show="slideIndex == 15">{{ $t("module1.slide16.heading") }}</h1>
      </transition>
      <transition name="fadeUp" appear>
        <h2 v-show="slideIndex == 15" class="delay-1">
          {{ $t("module1.slide16.number") }}
        </h2>
      </transition>
    </header>
    <transition name="fadeUp" appear>
      <h3 v-show="slideIndex == 15" class="delay-2">
        {{ $t("module1.slide16.number") }}
      </h3>
    </transition>
    <transition name="fadeUp" appear>
      <h4 v-show="slideIndex == 15" class="delay-3">
        {{ $t("module1.slide16.heading2") }}
      </h4>
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 15"
        src="@/assets/module1/slide16/characters-01.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fade">
      <video
        :src="videoURL"
        v-if="showVideo"
        controls
        autoplay
        ref="video"
      ></video>
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 15"
        src="@/assets/module1/slide16/video-01.png"
        class="chars delay-7"
      />
    </transition>
    <a href="" class="btn" @click.prevent="playVideo(videoID)">
      <transition name="fadeRight" appear>
        <img
          class="delay-8"
          v-show="slideIndex == 15"
          src="@/assets/module1/slide16/play_button.svg"
        />
      </transition>
    </a>
    <div class="flex">
      <div class="flex-1 left">
        <transition name="fadeUp" appear>
          <p v-show="slideIndex == 15" class="delay-5">
            To be the best FAST Hero ever you must never forget the Magic Number
            106.
          </p>
        </transition>
      </div>
      <div class="flex-1 right">
        <transition name="fadeUp" appear>
          <p v-show="slideIndex == 15" class="delay-6">
            I bet you can’t wait to meet the FAST Heroes? Let me introduce them.
          </p>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { log } from "../../../utils/log";
import vidEnd from "../../../utils/vid";

export default {
  data() {
    return {
      showVideo: false,
      videoURL:
        window?.CF_EBOOK_VARS?.videos?.book_1_video_1?.hd_large?.url ||
        "https://player.vimeo.com/external/404586820.hd.mp4?s=017fed36e8cc7fe4b44dd8ce7a1e6b62d928840e&profile_id=174&autoplay=1",
      videoID:
        window?.CF_EBOOK_VARS?.videos?.book_1_video_1?.video_id || "test_id"
    };
  },
  props: ["slideIndex"],
  methods: {
    playVideo(id) {
      log.videoView(id);
      this.showVideo = true;
      vidEnd(this);
    }
  }
};
</script>
